module.exports = __webpack_public_path__ + "img/2.48b9f6c0.png";